import { type MobileLayoutPages } from '../../types';
import HostedMobileInitPage from './MobileInitPage';
import HostedMobileWaitingPage from './MobileWaitingPage';
import HostedMobileAgentStartPage from './MobileAgentStartPage';
import HostedMobileAppPairingPage from './MobileAppPairingPage';
import HostedMobileDonePage from './MobileDonePage';
import HostedMobileAbortPage from './MobileAbortPage';
import HostedMobileFlowStartPage from './MobileFlowStartPage';
import HostedMobileAppPickerPage from './MobileAppPickerPage';
import HostedMobileAppInstallPage from './MobileAppInstallPage';
import HostedPassthroughShell from '../../../layouts/PassthroughShell';

export const hostedMobilePages: MobileLayoutPages = {
  Shell: HostedPassthroughShell,
  Loading: HostedMobileInitPage,
  Init: HostedMobileInitPage,
  Auth: HostedMobileInitPage,
  WaitingForPresentation: HostedMobileWaitingPage,
  AgentStart: HostedMobileAgentStartPage,
  AppPairing: HostedMobileAppPairingPage,
  Done: HostedMobileDonePage,
  Abort: HostedMobileAbortPage,
  FlowStart: HostedMobileFlowStartPage,
  AppPicker: HostedMobileAppPickerPage,
  AppInstall: HostedMobileAppInstallPage,
};

export { default as HostedMobileFlowStartPage } from './MobileFlowStartPage';
export { default as HostedMobileAppPickerPage } from './MobileAppPickerPage';
export { default as HostedMobileAppInstallPage } from './MobileAppInstallPage';
